<div class="row justify-content-center">
    @if (!IsDispatch) {
    <div class="row no-gutters justify-content-between my-2">
        <div class="col-1"></div>
        <mat-button-toggle-group [(ngModel)]="InterventionStatusMode" class="col-4 p-0">
            <mat-button-toggle class="col" [class.selected]="InterventionStatusMode === 1" [value]="1" (click)="getInterventionNewed()">
                <div>En attente de confirmation</div>
            </mat-button-toggle>
            <mat-button-toggle class="col" [class.selected]="InterventionStatusMode === 2" [value]="2" (click)="getInterventionInProgress()">
                <div>Planifiées</div>
            </mat-button-toggle>
        </mat-button-toggle-group>
        <mat-slide-toggle class="col-auto" labelPosition="after" [(ngModel)]="DisplayCalendarMode">
            Calendrier
        </mat-slide-toggle>
    </div>
    }

    <mat-chip-set multiple class="col">
        @for (m of SamplingPointInterventionList; track m) {
        <mat-chip class="clickable" [highlighted]="m.IsSelected" color="primary" (click)="toggleSamplingPointSelection(m)">
            {{m.StrategyId}} - {{m.SamplingPoint.Name}}
        </mat-chip>
        }
        @if (SamplingPointInterventionList?.length > 0) {
        <mat-chip class="clickable" color="accent" selected (click)="selectAllStrategy()">Tous</mat-chip>
        }
        @if (SamplingPointInterventionList?.length > 0) {
        <mat-chip class="clickable" color="warn" selected (click)="deselectAllStrategy()">Aucun</mat-chip>
        }
    </mat-chip-set>

    @if (!DisplayCalendarMode) {
    <div class="row justify-content-center mt-3">
        <div class="row justify-content-center">
            <mat-chip-set multiple class="col-auto p-1">
                <mat-chip style="background-color: #96aff2" selected>Avant travaux</mat-chip>
                <mat-chip style="background-color: #0072bc" selected> Pendant travaux</mat-chip>
                <mat-chip style="background-color: #3fb096" selected> Après travaux</mat-chip>
                <mat-chip style="background-color: pink" selected> Autres</mat-chip>
            </mat-chip-set>
        </div>
        @for (int of Model; track int) {
        <div [class]="int.Type === ECalendarType.Event ? 'col-12 col-md-4 col-xl-3 m-1' : 'col-12 m-1'">
            <!-- <mat-divider *ngIf="int.Type === ECalendarType.NewWeek" class="mt-3"></mat-divider> -->
            @if (Model.length > 0 && int.Type === ECalendarType.NewMonth) {
            <div class="row align-items-center">
                <div class="col-1 col-span-5">
                    <div class="sidebar" style="height: 2px;"></div>
                </div>
                <h1 class="col-auto p-2 text-center month">
                    {{lodash.upperFirst($safeNavigationMigration(int.Date?.toLocaleString('default', { year: 'numeric', month: 'long' })))}}
                </h1>
                <div class="col">
                    <div class="sidebar" style="height: 2px;"></div>
                </div>
            </div>
            }
            @if (Model.length > 0 && int.Type === ECalendarType.NewWeek) {
            <div class="row align-items-center">
                <div class="col-2">
                </div>
                <h3 class="col-auto text-center text-secondary">
                    {{getFirstDayOfTheWeek(int.Date).toLocaleString('default', { weekday:'short', day: 'numeric' })}}
                    -
                    {{getLastDayOfTheWeek(int.Date).toLocaleString('default', { weekday:'short', day: 'numeric' })}}
                </h3>
                <div class="col-6">
                    <div class="dashed" style="height: 2px"></div>
                </div>
                <span class="col-auto fst-italic text-secondary">Sem {{getWeekNumber(int.Date)}}</span>
            </div>
            }
            @if (Model.length > 0 && int.Type === ECalendarType.Event) {
            <div>
                <div>
                    <div class="card h-100 w-100" (click)="navigateToOrder(int.Data)" [class]="int.Data.Status === 4 ? 'hatched' : 'clickable'">
                        <h5 class="card-header">{{int.Data.SamplingPoint.Name}}
                            @if (int.Data.Status === 3) {
                            <span style="color: white !important; border-radius: 5px !important;" class="badge text-bg-success">Terminée</span>
                            }
                            @if (InterventionStatusMode === 2 && !hasQuiteSameDate(int.Data.RequiredOn, int.Data.PlannedOn)) {
                            <mat-icon class="material-symbols-outlined" matTooltip="Date/horaire différent de celui initialement mentionné">new_releases</mat-icon>
                            }
                        </h5>
                        <h6 class="fst-italic text-center">{{int.Data.Status === 4 ? '(Canceled)' : ''}} </h6>
                        <div class="card-body pb-1">
                            <p class="card-title text-center">Intervention N° {{int.Data.Id}}</p>
                            <p class="card-text text-center">{{int.Data.Comment}}</p>
                            <div class="row mt-2">
                                <mat-chip-set class="col">
                                    @for (m of FlattenClientMeasure(int.Data.MeasureList); track m) {
                                    <mat-chip [matTooltip]="getMeasureFullName(m)" [matBadge]="GetCountOfSameClientMeasure(m, int.Data.MeasureList)"
                                        [matBadgeHidden]="" matBadgeColor="accent" [style.background]="getColorByUasge(m)">
                                        <span>
                                            {{ m.ParentName.length > 20 ? m.ParentName.substring(0, 20)+'...' : m.ParentName}}
                                        </span>
                                    </mat-chip>
                                    }
                                </mat-chip-set>
                            </div>
                            @if (!int.TimeSlot) {
                            <p class="card-text fw-bold text-end text-muted p-0">{{int.Date | date:'EEEE d MMMM à HH:mm' }}</p>
                            }
                            @if (int.TimeSlot) {
                            <p class="card-text fw-bold text-end text-muted p-0">
                                {{int.Date | date:'EEEE d MMMM' }}
                                <span>({{getTimeSlotName(int.TimeSlot)}})</span>
                            </p>
                            }
                            <!-- <p class="card-text fw-bold text-end text-muted p-0">{{int.Data.wn}} - {{int.Data.RequiredOn | date:'shortDate' }}</p> -->
                        </div>
                    </div>
                </div>
            </div>
            }
        </div>
        }
    </div>
    }
    @if (DisplayCalendarMode) {
    <div>
        <div class="row text-center justify-content-between">
            <div class="col-1"></div>
            <div class="col-auto">
                <h3>{{ viewDate | calendarDate:(view + 'ViewTitle'):'fr' }}</h3>
            </div>
            <div class="col-auto ">
                <div class="btn-group">
                    <mat-button-toggle-group>
                        <mat-button-toggle mat-raised-button mwlCalendarPreviousView [view]="view" [(viewDate)]="viewDate"
                            (viewDateChange)="closeOpenMonthViewDay()">
                            <mat-icon class="material-symbols-outlined">arrow_back</mat-icon>
                        </mat-button-toggle>
                        <mat-button-toggle mat-raised-button mwlCalendarToday [(viewDate)]="viewDate" (viewDateChange)="closeOpenMonthViewDay()">
                            <mat-icon class="material-symbols-outlined">restore</mat-icon>
                        </mat-button-toggle>
                        <mat-button-toggle mat-raised-button mwlCalendarNextView [view]="view" [(viewDate)]="viewDate"
                            (viewDateChange)="closeOpenMonthViewDay()">
                            <mat-icon class="material-symbols-outlined">arrow_forward</mat-icon>
                        </mat-button-toggle>
                    </mat-button-toggle-group>
                </div>
            </div>
        </div>
        <div class="row">
            <mwl-calendar-month-view [weekStartsOn]="1" [locale]="locale" [viewDate]="viewDate" [events]="events" [refresh]="refresh"
                [activeDayIsOpen]="activeDayIsOpen" (dayClicked)="dayClicked($event.day)" (eventClicked)="handleEvent('Clicked', $event.event)"
                [openDayEventsTemplate]="customOpenDayEventsTemplate" [cellTemplate]="customCellTemplate">
            </mwl-calendar-month-view>
        </div>
    </div>
    }
</div>
<ng-template #customOpenDayEventsTemplate let-events="events" let-isOpen="isOpen" let-eventClicked="eventClicked">

    @if (isOpen) {
    <div class="cal-open-day-events" [@collapse]>
        @for (event of events; track event; let i = $index) {
        <div [ngClass]="$safeNavigationMigration(event?.cssClass)">
            @if (i === 0 || !hasSameSamplingPointName(events[i].meta.id, events[i - 1].meta.id)) {
            <h3>{{getSamplingPointBySamlingId(event.meta.id)}}</h3>
            }
            <span class="cal-event" [style.backgroundColor]="event.color?.primary"></span>
            <mwl-calendar-event-title [event]="event" view="month" (mwlClick)="eventClicked.emit({event: event})">
            </mwl-calendar-event-title>
            @if (InterventionStatusMode === 2 && !hasQuiteSameDateForCalendar(events)) {
            <mat-icon class="material-symbols-outlined" class="ms-1" matTooltip="Date/horaire différent de celui initialement mentionné"
                style="color: white;vertical-align: top;">new_releases</mat-icon>
            }
        </div>
        }
    </div>
    }

</ng-template>
<ng-template #customCellTemplate let-day="day" let-openDay="openDay" let-locale="locale" let-tooltipPlacement="tooltipPlacement" let-highlightDay="highlightDay"
    let-unhighlightDay="unhighlightDay" let-eventClicked="eventClicked" let-tooltipTemplate="tooltipTemplate" let-tooltipAppendToBody="tooltipAppendToBody"
    let-tooltipDelay="tooltipDelay" let-trackByEventId="trackByEventId" let-validateDrag="validateDrag">
    <div class="cal-cell-top">
        @if (day.badgeTotal > 0) {
        <mat-icon class="material-symbols-outlined" class="mt-3 ms-1 material-icons-outlined" color="primary">emoji_transportation</mat-icon>
        }
        @if (InterventionStatusMode === 2 && !hasQuiteSameDateForCalendar(day.events)) {
        <mat-icon class="material-symbols-outlined" matTooltip="Date/horaire différent de celui initialement mentionné">new_releases</mat-icon>
        }
        <span class="cal-day-number">{{ day.date | calendarDate:'monthViewDayNumber':locale }}</span>
    </div>

    @if (day.events.length > 0) {
    <div class="cal-events">
        @for (event of day.events; track event) {
        <div class="cal-event" [ngStyle]="{ backgroundColor: $safeNavigationMigration(event.color?.primary) }" [ngClass]="$safeNavigationMigration(event?.cssClass)"
            [mwlCalendarTooltip]="event.title | calendarEventTitle: 'monthTooltip':event" [tooltipPlacement]="tooltipPlacement" [tooltipEvent]="event"
            [tooltipTemplate]="tooltipTemplate" [tooltipAppendToBody]="tooltipAppendToBody" [tooltipDelay]="tooltipDelay" mwlDraggable
            [class.cal-draggable]="event.draggable" dragActiveClass="cal-drag-active" [dropData]="{ event: event, draggedFrom: day }"
            [dragAxis]="{ x: event.draggable, y: event.draggable }" [validateDrag]="validateDrag" [touchStartLongPress]="{ delay: 300, delta: 30 }"
            (mwlClick)="eventClicked.emit({ event: event, sourceEvent: $event })" [attr.aria-hidden]="{} | calendarA11y: 'hideMonthCellEvents'"
            class="border rounded-circle border-secondary" style="width: 20px; height: 20px; margin-left: 2px;">
        </div>
        }
    </div>
    }
</ng-template>